import type { CreatorEntity } from "shared/schema";
import { splitEntity } from "shelving";
import { GroupAdminCondition } from "../group/GroupAdminCondition.js";
import { ProfileOwnerCondition } from "../profile/ProfileOwnerCondition.js";

/** Only render children if the current logged in user is the creator of the entity. */
export function CreatorCondition({ creator, children, fallback }: { creator: CreatorEntity; children: React.ReactNode; fallback?: React.ReactNode }): React.ReactElement | null {
	const [type, id] = splitEntity(creator);
	return type === "profile" ? ( //
		<ProfileOwnerCondition uid={id} fallback={fallback} children={children} />
	) : type === "group" ? (
		<GroupAdminCondition gid={id} fallback={fallback} children={children} />
	) : null;
}
